export default function generatePassword() {
    const chars = {
      lower: "abcdefghijklmnopqrstuvwxyz",
      upper: "ABCDEFGHIJKLMNOPQRSTUVWXYZ",
      digits: "0123456789",
      special: "!@#$%^&*()-_=+[]{}|;:',.<>?/`~"
    };
    const all = chars.lower + chars.upper + chars.digits + chars.special;
    
    // Déterminer une longueur aléatoire entre 12 et 20 caractères
    const length = Math.floor(Math.random() * 9) + 12;
    
    // Garantir au moins un caractère de chaque type
    let password = [
      chars.lower[Math.floor(Math.random() * chars.lower.length)],
      chars.upper[Math.floor(Math.random() * chars.upper.length)],
      chars.digits[Math.floor(Math.random() * chars.digits.length)],
      chars.special[Math.floor(Math.random() * chars.special.length)]
    ];
    
    // Remplir le reste avec des caractères aléatoires
    while (password.length < length) {
      password.push(all[Math.floor(Math.random() * all.length)]);
    }
    
    // Mélanger le tableau pour éviter un motif prévisible
    return password.sort(() => Math.random() - 0.5).join('');
}
  